import { useAssistantProfile } from "../../modules/assistant/hooks/useAssistantProfile";
import { MOCHI_SYSTEM_DEFAULTS } from "./avatars";

/** Effective Mochi config: the profile endpoint's `resolved` block, or the
 * system defaults while the query is loading / when no resolved block exists,
 * so Mochi renders immediately rather than blank. */
export function useAssistantConfig() {
  const { data } = useAssistantProfile();
  const r = data?.resolved;
  return {
    assistant_name: r?.assistant_name || MOCHI_SYSTEM_DEFAULTS.assistant_name,
    avatar: r?.avatar || MOCHI_SYSTEM_DEFAULTS.avatar,
    palette: r?.palette || MOCHI_SYSTEM_DEFAULTS.palette,
    avatar_size: r?.avatar_size || MOCHI_SYSTEM_DEFAULTS.avatar_size,
    avatar_placement: r?.avatar_placement || MOCHI_SYSTEM_DEFAULTS.avatar_placement,
    mochi_enabled: r?.mochi_enabled ?? MOCHI_SYSTEM_DEFAULTS.mochi_enabled,
    avatar_hue: r?.avatar_hue ?? 250,
    ai_available: r?.ai_available ?? true,
    /** The organization lets people talk to Mochi (an org setting, default on). */
    chat_enabled: r?.chat_enabled ?? true,
  };
}
